import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver } from "../../utils/utils";



@Component({
  tag: 'ping-pong',
  styleUrl: 'ping-pong.css',
  shadow: true,
})
export class PingPong {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * The description
   */
  @Prop() description: string;

  /**
   * Text Orientation
   */
  @Prop() textOrientation: string;

  /**
   * Buttons Data
   */
  @Prop() buttonsData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Image alt
   */
  @Prop() imageAlt: string;

  /**
   * Image Url
   */
  @Prop() imageUrl: any;

  /**
   * Video
   */
  @Prop() videoUrl: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  componentDidLoad() {
    addIntersectionObserver(this.el.shadowRoot.querySelector('.ping-pong-container'), () => {
      this.el.shadowRoot.querySelector('.ping-pong-container').classList.add('animate');
    }, ['.overlay1', '.overlay2']);
  }

  render() {
    const buttons = JSON.parse(this.buttonsData);
    //console.log('data', this.imageUrl);
    return (
      <Host>
        <div
          style={{ backgroundImage: `url(${this.backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
          class={`ping-pong  ${this.paddingBottom} ${this.paddingTop} ${this.backgroundColor}`}
        >
          <div class={`ping-pong-container container ${this.textOrientation} ${this.textColor} `}>
            <div class={`ping-pong-content`}>
              <div class={`overlay1 ${this.backgroundColor} `}></div>
              {this.mainTitle && <h3 class={`ping-pong-title`}>{this.mainTitle}</h3>}
              {this.description && <div class={`ping-pong-description`} innerHTML={this.description}></div>}
              {buttons && buttons.length > 0 && (
                <div class={`ping-pong-buttons`}>
                  {buttons.map(button => (
                    <button-block buttonsData={button}></button-block>
                  ))}
                </div>
              )}
            </div>
            <div class={`ping-pong-asset-wrapper `}>
              <div class={`overlay2 ${this.backgroundColor} `}></div>
              {this.assetType === 'image' && this.imageUrl && <image-block imageClass={`ping-pong-asset`} imageUrl={this.imageUrl} imageAlt={this.imageAlt}></image-block>}
              {this.assetType === 'video' && this.videoUrl && <video-block videoUrl={this.videoUrl} videoClass={`aspect-video w-full h-full`}></video-block>}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
